import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";


export const fetchAmenitiesList = createAsyncThunk(
    "fetchAmenitiesList",
    async (practiceId) => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/practices/${practiceId}/amenities`);
        return result;
    }
)


export const fetchParkingOptionsList = createAsyncThunk(
    "fetchParkingOptionsList",
    async (practiceId) => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/practices/${practiceId}/parking-options`);
        return result;
    }
)


export const fetchAmenityCheckList = createAsyncThunk(
    "fetchAmenityCheckList",
    async () => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/amenities`);
        return result;
    }
)


export const fetchParkingOptionsCheckList = createAsyncThunk(
    "fetchParkingOptionsCheckList",
    async () => {
        const result = await FetchRequestHandler("get", `${baseUrl}api/parking-options`);
        return result;
    }
)


export const fetchUpdateAmenitiesList = createAsyncThunk(
    "updateAmenitiesList",
    async ({ practiceId, payload }) => {
        const result = await FetchRequestHandler("put", `${baseUrl}api/practices/${practiceId}/amenities`, payload);
        return result;
    }
)


export const fetchDeleteAmenity = createAsyncThunk(
    "deleteAmenity",
    async ({ practiceId, displayId }) => {
        const result = await FetchRequestHandler("delete", `${baseUrl}api/practices/${practiceId}/amenities/${displayId}`, []);
        return result;
    }
)


export const fetchDeleteParkingOptions = createAsyncThunk(
    "deleteParkingOptions",
    async (practiceId) => {
        const result = await FetchRequestHandler("put", `${baseUrl}api/practices/${practiceId}/parking-options`, {});
        return result;
    }
)


export const fetchUpdateParkingOptionsList = createAsyncThunk(
    "updateParkingOptionsList",
    async ({ practiceId, payload }) => {
        const result = await FetchRequestHandler("put", `${baseUrl}api/practices/${practiceId}/parking-options`, payload);
        return result;
    }
)